<div style="display: inline-flex; justify-content: space-between; width:100%;" *ngIf="!isHistoryView">
  <div class="fusion-button-wrapper fusion-align-block">
    <style type="text/css">
      .fusion-button.button-37 {
        border-radius: 0px;
      }
    </style><a (click)="createAnnouncement()" class="
        fusion-button
        button-flat
        fusion-button-default-size
        button-default button-37
        fusion-button-span-yes fusion-button-default-type
      " target="_self"><span class="fusion-button-text">CREA ANNUNCIO</span></a>
  </div>
  <span style="color: #ffa626;font-family: Montserrat, Arial, Helvetica, sans-serif;cursor: pointer;">
    <strong (click)="loadClosed()">{{goToClosedLinkLabel}} &gt;</strong>
  </span>
</div>
<p style="text-align: right;" *ngIf="isHistoryView">
  <span style="color: #ffa626;font-family: Montserrat, Arial, Helvetica, sans-serif;cursor: pointer;">
    <strong (click)="loadCurrent()">&lt; {{backLinkLabel}}</strong>
  </span>
</p>
<div class="fusion-sep-clear"></div>
<div
  *ngIf="(!isHistoryView && (!openedAnnouncementCards || openedAnnouncementCards.length === 0)) || (isHistoryView && (!closedAnnouncementCards || closedAnnouncementCards.length === 0))"
  style="text-align: center;margin-top: 8vh;margin-bottom: 8vh;">
  <p style="font-size: 1.5rem;"><strong>{{emptyLabel}}</strong></p>
</div>
<div class="fusion-separator fusion-full-width-sep sep-none"
  style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
<div *ngFor="let card of openedAnnouncementCards">
  <div
    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_1 fusion-builder-nested-column-5 fusion-one-full fusion-column-first fusion-column-last 1_1"
    style='margin-top: 0px;margin-bottom: 0px;'>
    <div class="fusion-column-wrapper fusion-column-wrapper-5"
      style="background-color:var(--ng-app-light-grey-color);padding: 0px 0px 10px 20px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
      data-bg-url="">
      <div style="display: inline-flex; justify-content: right; width:100%;">
        <div *ngIf="card.announcementOffers.length > 0" class="fusion-text" style="margin-right: 5px;">
          <p style="text-align: right;margin-bottom: 4px;line-height: 1.2;"><span
              class="ng-announcement-offer">{{card.announcementOffers.length + ' Offerte'}}</span></p>
        </div>
        <div class="fusion-text" style="margin-right: 5px;">
          <p style="text-align: right;margin-bottom: 4px;line-height: 1.2;"><span
              class="ng-announcement-status">{{getTypeDescription(card.announcementType)}}</span></p>
        </div>
        <div class="fusion-text">
          <p style="text-align: right;margin-bottom: 4px;line-height: 1.2;"><span
              class="ng-tender-status">{{getStatusDescription(card.announcementStatus)}}</span></p>
        </div>
      </div>
      <div class="fusion-builder-row-2" style="padding-right: 20px">
        <div class="fusion-text">
          <p class="ng-tender-title"><strong>{{card.title}}</strong></p>
        </div>
        <div class="ng-tender-description">
          <h5 style="font-size: 17px;">{{card.description}}</h5>
        </div>
      </div>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row" style="padding-right: 20px">
        <div
          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-1 fusion-one-half fusion-column-first 1_2"
          style='margin-top: 10px; margin-bottom: 10px; width: 50%; width: calc(50% - ( ( 4% ) * 0.5 ) ); margin-right: 4%;'>
          <div class="fusion-column-wrapper fusion-column-wrapper-1">
            <div class="fusion-text">
              <h5>Categoria: {{card.categoryName}}</h5>
              <h5>Province: {{getProvincesAsString(card)}}</h5>
            </div>
          </div>
        </div>
        <div
          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-2 fusion-one-half fusion-column-last 1_2 ng-tender-detail-link"
          style="margin-top: 10px; margin-bottom: 10px; width: 50%; width: calc(50% - ( ( 4% ) * 0.5 ) );">
          <style type="text/css">
            @media only screen and (max-width:800px) {
              .ng-div-detail-link {
                margin-top: 0px !important;
              }

              .ng-detail-link {
                padding-top: 0px !important;
              }
            }
          </style>
          <div style="display: inline-flex; justify-content: space-between; width:100%;">
            <div class="fusion-column-wrapper fusion-column-wrapper-2 ng-div-detail-link" style="margin-top: 14px;">
              <div class="fusion-text">
                <p style="text-align: right;padding-top: 25px;margin-bottom: 0;cursor: pointer;" class="ng-detail-link"
                  *ngIf="isDetailVisible(card.tenderStatus)">
                  <a (click)="deleteAnnouncement(card)">Elimina &gt;</a>
                </p>
              </div>
            </div>
            <div class="fusion-column-wrapper fusion-column-wrapper-2 ng-div-detail-link" style="margin-top: 14px;">
              <div class="fusion-text">
                <p style="text-align: right;padding-top: 25px;margin-bottom: 0;cursor: pointer;" class="ng-detail-link"
                  *ngIf="isDetailVisible(card.tenderStatus)">
                  <a (click)="goToDetail(card)">Vai al dettaglio &gt;</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fusion-sep-clear"></div>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
  </div>
</div>
<div *ngFor="let card of closedAnnouncementCards">
  <div
    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_1 fusion-builder-nested-column-5 fusion-one-full fusion-column-first fusion-column-last 1_1"
    style='margin-top: 0px;margin-bottom: 0px;'>
    <div class="fusion-column-wrapper fusion-column-wrapper-5"
      style="background-color:var(--ng-app-light-grey-color);padding: 0px 0px 10px 20px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
      data-bg-url="">
      <div style="display: inline-flex; justify-content: right; width:100%;">
        <div class="fusion-text" style="margin-right: 5px;">
          <p style="text-align: right;margin-bottom: 4px;line-height: 1.2;"><span
              class="ng-announcement-status">{{getTypeDescription(card.announcementType)}}</span></p>
        </div>
        <div class="fusion-text">
          <p style="text-align: right;margin-bottom: 4px;line-height: 1.2;"><span
              class="ng-tender-status">{{getStatusDescription(card.announcementStatus)}}</span></p>
        </div>
      </div>
      <div class="fusion-builder-row-2" style="padding-right: 20px">
        <div class="fusion-text">
          <p class="ng-tender-title"><strong>{{card.title}}</strong></p>
        </div>
        <div class="ng-tender-description">
          <h5 style="font-size: 17px;">{{card.description}}</h5>
        </div>
      </div>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row" style="padding-right: 20px">
        <div
          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-1 fusion-one-half fusion-column-first 1_2"
          style='margin-top: 10px; margin-bottom: 10px; width: 50%; width: calc(50% - ( ( 4% ) * 0.5 ) ); margin-right: 4%;'>
          <div class="fusion-column-wrapper fusion-column-wrapper-1">
            <div class="fusion-text">
              <h5>Categoria: {{card.categoryName}}</h5>
              <h5>Province: {{card.provinces}}</h5>
            </div>
          </div>
        </div>
        <div
          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-2 fusion-one-half fusion-column-last 1_2 ng-tender-detail-link"
          style="margin-top: 10px; margin-bottom: 10px; width: 50%; width: calc(50% - ( ( 4% ) * 0.5 ) );">
          <style type="text/css">
            @media only screen and (max-width:800px) {
              .ng-div-detail-link {
                margin-top: 0px !important;
              }

              .ng-detail-link {
                padding-top: 0px !important;
              }
            }
          </style>
          <div class="fusion-column-wrapper fusion-column-wrapper-2 ng-div-detail-link" style="margin-top: 14px;">
            <div class="fusion-text">
              <p style="text-align: right;padding-top: 25px;margin-bottom: 0;cursor: pointer;" class="ng-detail-link"
                *ngIf="isDetailVisible(card.tenderStatus)">
                <a (click)="goToDetail(card)">Vai al dettaglio &gt;</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fusion-sep-clear"></div>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
  </div>
</div>
<div class="fusion-sep-clear"></div>
<div class="fusion-separator fusion-full-width-sep sep-none"
  style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
<div class="fusion-text" *ngIf="showMore">
  <p style="text-align: right;padding-top: 25px;margin-bottom: 0;"><a style="font-weight: 600;cursor: pointer;"
      (click)="loadMore()" target="_self">{{showMoreLabel}} &gt;</a></p>
</div>
<app-modal #confirmationModal>
  <ng-template #header>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 100px"></div>
    <div class="fusion-text">
      <h3 style="text-align: center">ATTENZIONE</h3>
    </div>
  </ng-template>
  <ng-template #body>
    <div class="fusion-text">
      <h5>{{ confirmationModalMsg }}</h5>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-21
          fusion-one-fourth
          fusion-column-last
          1_2
        " style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 50%;
          width: calc(50% - ((1%) * 0.5));
        ">
        <div class="fusion-column-wrapper fusion-column-wrapper-22" style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-right: 4%;
          " data-bg-url="">
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }
            </style>
            <a (click)="confirmationModalSubmit()" class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              " target="_self"><span class="fusion-button-text fusion-button-text-left">{{
                confirmationModalSubmitMsg
                }}</span></a>
          </div>
        </div>
      </div>
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-22
          fusion-one-fourth
          fusion-column-last
          1_2
        " style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 50%;
          width: calc(50% - ((1%) * 0.5));
        ">
        <div class="fusion-column-wrapper fusion-column-wrapper-22" style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-left: 4%;
          " data-bg-url="">
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }
            </style>
            <a (click)="confirmationModal.close()" class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              " target="_self"><span class="fusion-button-text fusion-button-text-left">ANNULLA</span></a>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</app-modal>

<app-modal #denialModal>
  <ng-template #header>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 100px"></div>
    <div class="fusion-text">
      <h3 style="text-align: center">ATTENZIONE</h3>
    </div>
  </ng-template>
  <ng-template #body>
    <div class="fusion-text">
      <h5>Per usufruire della funzionalità di creazione e pubblicazione di annunci deve avere eseguito almeno una
        transazione (acquisto abbonamento o singola gara) per creare o per partecipare alle gare su SKIMMING</h5>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-21
          fusion-one-fourth
          fusion-column-last
          1_2
        " style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 100%;
        ">
      </div>
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-22
          fusion-one-fourth
          fusion-column-last
          1_2
        " style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 100%;
          width: calc(100% - ((1%) * 0.5));
        ">
        <div class="fusion-column-wrapper fusion-column-wrapper-22" style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-left: 4%;
          " data-bg-url="">
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }
            </style>
            <a (click)="denialModal.close()" class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              " target="_self"><span class="fusion-button-text fusion-button-text-left">OK</span></a>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</app-modal>